import { render, staticRenderFns } from "./sublegstats.vue?vue&type=template&id=b13ecf9a&"
import script from "./sublegstats.vue?vue&type=script&lang=js&"
export * from "./sublegstats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports